<template>
  <div class="foundation">
    <h1>{{ $t("foundation.title") }}</h1>

    <section class="links">
      <p>{{ $t("foundation.intro") }}</p>

      <f-button @click="scrollToSection('policy')" :type="'outline'">{{
        $t("policy.title")
      }}</f-button>
      <f-button @click="scrollToSection('governance')" :type="'outline'">{{
        $t("governance.title")
      }}</f-button>
      <f-button @click="scrollToSection('justification')" :type="'outline'">{{
        $t("justification.title")
      }}</f-button>
    </section>

    <div class="horizontal-line"></div>

    <!-- Policy: Beleid -->
    <section class="policy" id="policy">
      <h2>{{ $t("policy.title") }}</h2>

      <!-- missie -->
      <h3>{{ $t("policy.title3") }}</h3>
      <p>{{ $t("policy.content2") }}</p>
      <p>{{ $t("policy.content3") }}</p>

      <!-- focus -->
      <h3>{{ $t("policy.title4") }}</h3>
      <p>{{ $t("policy.content4") }}</p>

      <div class="categories">
        <div>
          <img src="@/assets/img/icon_health.png" />
          <p>{{ $t("policy.listItem1") }}</p>
        </div>
        <div>
          <img src="@/assets/img/icon_scouting.png" />
          <p>{{ $t("policy.listItem2") }}</p>
        </div>
        <div>
          <img src="@/assets/img/icon_culture.png" />
          <p>{{ $t("policy.listItem3") }}</p>
        </div>
        <div>
          <img src="@/assets/img/icon_kruimel.png" />
          <p>{{ $t("policy.listItem4") }}</p>
        </div>
        <div>
          <img src="@/assets/img/icon_other.png" />
          <p>{{ $t("policy.listItem5") }}</p>
        </div>
      </div>
      <p>{{ $t("policy.content5") }}</p>

      <!-- doelstelling -->
      <h3>{{ $t("policy.title2") }}</h3>
      <!-- <p>{{ $t('policy.content1') }}</p> -->
      <p class="light">{{ $t("introduction.intro3") }}</p>
      <p class="quote">{{ $t("introduction.intro4") }}</p>
    </section>

    <div class="horizontal-line"></div>
    <!-- Governance: Bestuur -->
    <section class="governance" id="governance">
      <h2>{{ $t("governance.title") }}</h2>
      <h3>{{ $t("governance.title2") }}</h3>
      <div class="cards">
        <div>
          <strong>{{ $t("governance.function1") }}</strong>
          <p>{{ $t("governance.name1") }}</p>
        </div>
        <div>
          <strong>{{ $t("governance.function2") }}</strong>
          <p>{{ $t("governance.name2") }}</p>
        </div>
        <div>
          <strong>{{ $t("governance.function3") }}</strong>
          <p>{{ $t("governance.name3") }}</p>
        </div>
      </div>
      <h3>{{ $t("governance.title3") }}</h3>
      <p>{{ $t("governance.content1") }}</p>
    </section>

    <div class="horizontal-line"></div>
    <!-- Justification: Verantwoording -->
    <section class="justification" id="justification">
      <h2>{{ $t("justification.title") }}</h2>

      <h3>{{ $t("policy.title5") }}</h3>
      <p>{{ $t("policy.content6") }}</p>

      <h3>{{ $t("policy.title6") }}</h3>
      <p>{{ $t("policy.content7") }}</p>

      <h3>{{ $t("policy.title7") }}</h3>

      <div class="cards">
        <a href="./files/justification_2025.pdf" target="_blank">2025</a>
        <a href="./files/justification_2024.pdf" target="_blank">2024</a>
        <a href="./files/justification_2023.pdf" target="_blank">2023</a>
        <a href="./files/justification_2022.pdf" target="_blank">2022</a>
        <a href="./files/justification_2021.pdf" target="_blank">2021</a>
        <a href="./files/justification_2020.pdf" target="_blank">2020</a>
      </div>

      <h3>{{ $t("policy.title8") }}</h3>

      <div class="cards">
        <a href="./files/activity_2025.pdf" target="_blank">2025</a>
        <a href="./files/activity_2024.pdf" target="_blank">2024</a>
        <a href="./files/activity_2023.pdf" target="_blank">2023</a>
        <a href="./files/activity_2022.pdf" target="_blank">2022</a>
      </div>
    </section>
  </div>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

export default {
  name: "Foundation",
  components: {},
  props: [],

  /* ------------------------------ */
  /* DATA */
  data() {
    return {};
  },

  /* ------------------------------ */
  /* LIFECYCLE HOOKS */
  /* note: do not use arrow functions here */
  beforeCreate: function () {},
  created: function () {},
  beforeMount: function () {},
  mounted: function () {},
  beforeDestroy: function () {},
  destroyed: function () {},

  /* ------------------------------ */
  /* METHODS ETC */
  methods: {
    scrollToSection: function (destination) {
      document
        .getElementById(destination)
        .scrollIntoView({ behavior: "smooth" });
    },
  },
  computed: {},
  watch: {},
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
.foundation {
  @include max-medium {
    margin-bottom: $margin-bottom-mobile;
  }

  @include min-large {
    margin-bottom: $margin-bottom-desktop;
  }
}

section {
  @include maxWidthCenter();
  padding-top: 50px;
  margin-bottom: 50px;
  padding-left: $padding-mobile;
  padding-right: $padding-mobile;
}

h2 {
  margin-bottom: 40px;
}

h3 {
  padding-top: 30px;
  margin-bottom: 14px;
}

#app .links {
  @include maxWidthCenter(700px);
  @include flex(space-around, center);
  flex-wrap: wrap;

  @include min-large {
    text-align: center;
  }

  p {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }

  button {
    @include max-medium {
      width: 100%;
      margin-top: 8px;
      margin-bottom: 8px;
    }

    @include min-large {
      width: 200px;
    }
  }
}

.policy {
  .categories {
    @include flex(center, stretch);
    margin-top: 30px;
    margin-bottom: 30px;

    @include max-medium {
      flex-wrap: wrap;
    }

    @include min-large {
      font-size: 80%;
    }

    div {
      flex-basis: 100%;
      margin-left: 8px;
      margin-right: 8px;
      padding: 12px 12px 8px;
      font-size: 16px;
      text-align: center;
      @include card-shadow();
      border-radius: $border-radius;

      @include max-medium {
        flex-wrap: wrap;
        margin-top: 12px;
        margin-bottom: 12px;
      }

      &:first-of-type {
        margin-left: 0;
      }
      &:last-of-type {
        margin-right: 0;
      }

      img {
        height: 80px;
        margin-bottom: 8px;
      }
      p {
        margin-top: auto;
        color: $dark-green;
        display: block;
        text-transform: uppercase;
        font-size: 80%;
        letter-spacing: 2px;
        font-weight: 600;
      }
    }
  }

  p.light,
  p.quote {
    padding-top: $p-padding;
    padding-bottom: $p-padding;
  }
}

.governance {
  /* ALL CARDS */
  .cards {
    @include flex(space-around, stretch);
    margin-top: 30px;

    @include max-medium {
      flex-direction: column;
    }

    /* SINGLE CARD */
    > div {
      padding: 20px 12px;
      text-align: center;
      // border: 1px solid $dark-green;
      @include card-shadow();
      border-radius: $border-radius;

      @include max-medium {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      @include min-large {
        width: 30%;
      }

      strong {
        color: $dark-green;
        display: block;
        text-transform: uppercase;
        font-size: 80%;
        letter-spacing: 2px;
        margin-bottom: 8px;
      }
    }
  }
}

.justification {
  .cards {
    @include flex(space-around, stretch);
    margin-top: 30px;

    @include max-medium {
      flex-direction: column;
    }

    /* SINGLE CARD */
    a {
      padding: 20px 12px;
      text-align: center;
      @include card-shadow();
      border-radius: $border-radius;
      background-color: $dark-green;
      color: white;
      font-weight: bold;

      @include max-medium {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      @include min-large {
        width: 20%;
        margin-left: 20px;
        margin-right: 20px;
      }

      &:hover {
        background-color: $green-4;
      }
    }
  }
}
</style>
